import { isUndefinedOrNull } from 'utils';

export const objToQueryParam = (obj: Object) => {
  const keyValuePairs = Object.entries(obj).map(([key, value]) => !isUndefinedOrNull(value) && `${key}=${value}`);
  let queryParam = keyValuePairs.filter((keyValuePair) => keyValuePair).join('&');

  if (queryParam) queryParam = '?' + queryParam;
  return queryParam;
};
